import React from "react";
import { FiArrowUp, FiArrowDown, FiMinus } from "react-icons/fi";

export default function KpiCard({
    title,
    value,
    unit,
    target,
    statusText,
    statusType, // improving | worsening | stable
    difference,
}) {
    const statusColors = {
        improving: "text-green-600 bg-green-50",
        worsening: "text-red-600 bg-red-50",
        stable: "text-slate-600 bg-slate-100",
    };

    const arrowIcons = {
        improving: <FiArrowUp size={14} />,
        worsening: <FiArrowDown size={14} />,
        stable: <FiMinus size={14} />,
    };

    return (
        <div className="bg-white p-3 rounded-xl border border-slate-200 shadow-sm w-full" style={{ height: "20vh"}}>
            <div className="text-[13px] text-slate-500 font-medium">{title}</div>

            <div className="text-3xl font-semibold mt-1">
                {value}
                <span className="text-sm text-slate-500 ml-1">{unit}</span>
            </div>

            <div className="text-[12px] text-slate-400 mt-1">
                Target: <span className="font-medium text-slate-500">{target}</span>
            </div>

            <div
                className={`mt-3 flex items-center gap-2 px-2 py-1 rounded-lg text-xs font-medium w-fit ${statusColors[statusType]}`}
            >
                {arrowIcons[statusType]}
                {statusText} ({difference})
            </div>

            <div className="mt-3 h-2 w-full rounded-full bg-slate-100">
                <div
                    className={`h-full rounded-full ${statusType === "worsening"
                            ? "bg-red-400"
                            : statusType === "improving"
                                ? "bg-green-500"
                                : "bg-slate-500"
                        }`}
                    style={{ width: "60%" }}
                ></div>
            </div>
        </div>
    );
}
